// import * as types from '../../mutation-types'
import RaceResumeService from '../../../services/raceResume'

const actions = {
  createOne ({ commit, state }, raceResume) {
    return RaceResumeService.create(raceResume)
  },
  getRaceResumesByRace ({ commit, state }, raceId) {
    return RaceResumeService.getRaceResumesByRace(raceId)
  }
}

export default actions



// WEBPACK FOOTER //
// ./src/store/modules/raceResume/actions.js